<template>
  <div class="card card-shadow mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between">
        <div class="form-inline">
          <b-form-select
            v-model="yearChartType"
            :select-size="1"
            @change="$emit('input', yearChartType)"
          >
            <option value="year">Aktuálne zvolený rok</option>
            <option value="prevyear">Predchádzajúci rok</option>
          </b-form-select>
        </div>
        <div>
          <b-btn class="ml-3" variant="secondary" @click="exportValues()">
            <b-icon class="mr-1" icon="file-earmark-excel" />
            Exportovať (xlsx)
          </b-btn>
          <b-btn class="ml-3" variant="secondary" @click="exportValues('csv')">
            <b-icon class="mr-1" icon="file-earmark-text" />
            Exportovať (csv)
          </b-btn>
        </div>
      </div>
    </div>
    <div class="card-body">
      <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
        <chart
          v-if="!loading"
          ref="bigchart"
          :constructor-type="'stockChart'"
          :options="chartOptions"
        />
      </b-overlay>
    </div>
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue'
import { minBy } from 'lodash'

export default {
  components: {
    Chart,
  },
  props: ['loading', 'yearChart', 'date'],
  data() {
    return {
      yearChartType: 'year',
      chartOptions: {
        chart: {
          height: '350px',
        },
        title: {
          text: null,
        },
        plotOptions: {
          series: {
            turboThreshold: 0,
            marker: {
              radius: 0,
              states: {
                hover: {
                  radiusPlus: 4,
                },
              },
            },
          },
        },
        legend: {
          enabled: true,
        },
        rangeSelector: {
          enabled: false,
          selected: 0,
        },
        navigator: {
          maskFill: 'rgba(113, 162, 65, .15)',
          adaptToUpdatedData: false,
        },
        scrollbar: {
          enabled: false,
        },
        tooltip: {
          shared: true,
          split: false,
          valueDecimals: 2,
          valueSuffix: ' m3',
        },
        xAxis: {
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: 'Namerané hodnoty (m3)',
          },
        },
        series: [
          {
            name: 'Hranica 100%',
            color: '#000',
            showInNavigator: false,
            lineWidth: 3,
            marker: {
              symbol: 'square',
            },
            data: [],
          },
          {
            name: 'Odber',
            color: '#6fa55a',
            showInNavigator: true,
            dataGrouping: {
              approximation: 'high',
            },
            data: [],
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'intervalove-data_report',
        },
      },
    }
  },
  watch: {
    yearChart: {
      handler() {
        this.chartUpdate()
      },
      immediate: true,
    },
  },
  methods: {
    chartUpdate() {
      this.chartOptions.series[0].data = this.yearChart.border100
      this.chartOptions.series[1].data = this.yearChart.values

      const series1 = this.chartOptions.series[1]
      const series2 = this.chartOptions.series[0]

      if (series2.data.length) {
        series1.zones = [
          { value: minBy(series2.data, 'y')?.y },
          { color: '#ff0000' },
        ]
      }
    },
    exportValues(type = 'xlsx') {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      let totalType
      switch (this.yearChartType) {
        case 'year':
          totalType = this.date.year
          break
        case 'prevyear':
          totalType = this.date.year - 1
          break
      }
      this.$api
        .get('energy_data/export_gas_total', {
          params: {
            id: this.$route.params.energetics_id,
            year: totalType,
            type: type,
          },
          responseType: 'blob',
        })
        .then((res) => {
          let date
          switch (this.yearChartType) {
            case 'year':
              date = this.date.year
              break
            case 'prevyear':
              date = this.date.year - 1
              break
          }
          saveAs(
            new Blob([res.data]),
            'intervalove-data_plyn-' + date + '.' + type,
          )
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
  },
}
</script>
